import React, { FC } from 'react';
import { EmptyCart } from '@components/Pages/CartPage/EmptyCart/EmptyCart';
import { ToysBlock } from '@components/Pages/CartPage/ToysBlock/ToysBlock';
import { ICartItemToys } from '@services/store/helpers/cart';
interface ListProps {
  list: ICartItemToys[];
  setList: React.Dispatch<React.SetStateAction<ICartItemToys[]>>;
}
export const ToysList: FC<ListProps> = ({
  list,
  setList
}) => <>
        {!list.length ? <EmptyCart /> : <ToysBlock list={list} setList={setList} />}
    </>;